import { Auth } from 'api';
import { getUserInfo } from 'base/actions/auth';
import cookie from 'react-cookie';

function loginWithFacebook(facebookAuth) {
  return function(dispatch) {
    return Auth.actions.loginWithFacebook.request(null, {
      data: {
        "accessToken": facebookAuth.accessToken
      }
    }).then(res => {
      let expiresParams = {path: '/'};

      cookie.save('accessToken', res.data.id, expiresParams);

      return dispatch(getUserInfo()).then(response => {
        return {
          isAuthenticated: true,
          data: response
        }
      })
    }).catch( (errors) => {
      // return {
      //   isAuthenticated: false,
      //   data: errors.response
      // }
      console.log(errors)
    });

  }
}

export {loginWithFacebook};



// WEBPACK FOOTER //
// ./actions/social-login/facebook.js